import { render } from "./Checkbox.vue?vue&type=template&id=74b94ae2"
import script from "./Checkbox.vue?vue&type=script&lang=js"
export * from "./Checkbox.vue?vue&type=script&lang=js"

import exportComponent from "/Users/alejandropascual/Websites/_CODEABLE/Task-171603-Beat/wordpress/wp-content/plugins/aps-modul-booking/_vue/shortcode_modul_courses/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__